import styled from 'styled-components';

export const AlertMessage = styled.div<{ $variant: 'warning' | 'success' }>`
  display: flex;
  align-items: flex-start;
  gap: 12px;
  padding: 16px;
  border-radius: 8px;
  background: ${({ theme, $variant }) =>
    $variant === 'warning' ? theme.colors.orange1 : theme.colors.green1};
  border: 1px solid
    ${({ theme, $variant }) =>
      $variant === 'warning' ? theme.colors.orange3 : theme.colors.green3};
`;

export const AlertMessageContent = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

export const AlertMessageTitle = styled.span`
  font-size: 14px;
  font-weight: 500;
  line-height: 20px;
  color: ${({ theme }) => theme.colors.black9};
`;

export const AlertMessageText = styled.p`
  margin: 0;
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
  color: ${({ theme }) => theme.colors.black9};
`;

export const CardsGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  gap: 12px;

  @media (min-width: ${({ theme }) => theme.mediaQueries.md}) {
    grid-template-columns: 1fr 1fr;
  }
`;

export const InfoCard = styled.div`
  display: flex;
  padding: 12px 16px;
  align-items: flex-start;
  gap: 16px;
  align-self: stretch;
  border-radius: 4px;
  border: 1px solid ${({ theme }) => theme.colors.black3};
  background: ${({ theme }) => theme.colors.white};
`;
export const InfoCardContent = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 4px;
`;
export const InfoCardIcon = styled.div`
  display: flex;
  width: 24px;
  height: 24px;
  padding: 10px;
  justify-content: center;
  align-items: center;
  gap: 10px;
  border-radius: 4px;
  border: 1px solid ${({ theme }) => theme.colors.purple3};
  background: ${({ theme }) => theme.colors.purple1};
  flex-shrink: 0;
`;
export const InfoCardLabel = styled.span`
  color: ${({ theme }) => theme.colors.black9};
  font-size: 12px;
  font-weight: 400;
  line-height: 16px;
`;

export const InfoCardValue = styled.span`
  overflow: hidden;
  color: ${({ theme }) => theme.colors.black9};
  text-overflow: ellipsis;
  font-size: 16px;
  font-weight: 600;
  line-height: 24px;
  letter-spacing: -0.2px;
`;
